module.exports = __webpack_public_path__ + "sul-logo.26a9c0b6a51d3994a394e717cc0b42a9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/less/img/sul-logo.svg
// module id = 10
// module chunks = 0